import React, { Component } from 'react';

import NavigationEntity from '../../../types/NavigationEntity';
import NavigationEntityLink from '../NavigationEntityLink';
import NavigationEntityTextItem from '../NavigationEntityTextItem';

class NavigationEntityItem extends Component {
  render() {
    const { entity, ...rest } = this.props;
    const { path } = entity;
    if (!entity) {
      return null;
    }

    const Component = path ? NavigationEntityLink : NavigationEntityTextItem;

    return <Component entity={entity} {...rest} />;
  }
}

NavigationEntityItem.propTypes = {
  entity: NavigationEntity.isRequired
};

export default NavigationEntityItem;



// WEBPACK FOOTER //
// ./src/components/navigation/NavigationEntityItem/index.jsx